import clsx from 'clsx'

const NotificationOption: React.FC<{ title: string; inApp: boolean; email: boolean }> = ({
	title,
	inApp,
	email,
}) => {
	return (
		<div className="row mb-5 mt-5 border-bottom pb-7 ms-0 me-0">
			<div className="col-3 col-xl-6 px-0">
				<div className="d-flex flex-column px-0">
					<span>{title}</span>
				</div>
			</div>
			<div className="col-9 col-xl-6">
				{/* Checkbox Version */}

				{/* <div className="row gx-2">
					<div className="col-12 col-xl-6">
						<div className="form-check">
							<input
								id={`in-app-${title}`}
								type="checkbox"
								className="form-check-input"
								checked={inApp}
							/>
							<label htmlFor={`in-app-${title}`} className="form-check-label">
								In App
							</label>
						</div>
					</div>
					<div className="col-12 col-xl-6">
						<div className="form-check">
							<input
								id={`email-${title}`}
								type="checkbox"
								className="form-check-input"
								checked={email}
							/>
							<label htmlFor={`email-${title}`} className="form-check-label">
								Email
							</label>
						</div>
					</div>
				</div> */}

				{/* Button Group Version */}

				<div className="kumopack-button-group justify-content-end">
					<button
						className={clsx('btn btn-sm white-button left', {
							active: inApp,
						})}>
						In-app
					</button>
					<button
						className={clsx('btn btn-sm white-button right', {
							active: email,
						})}>
						Email
					</button>
				</div>
			</div>
		</div>
	)
}

export default NotificationOption
